import { createMiddleware } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";

export const authMiddlewareServer = createMiddleware({
  type: "function",
}).server(async ({ next }) => {
  const { auth } = await import("../../auth/auth");
  const headers = getRequestHeaders();
  const session = await auth.api.getSession({
    headers,
  });

  if (!session) {
    throw new Error("Unauthorized");
  }

  const authContext = {
    ...session.user,
    userId: session.user.id,
    role: session.user.role as string,
  };

  return next({
    context: {
      auth: authContext,
    },
  });
});
